import { usePageModels } from '@/context/PageModels';
import {
  filter,
  includes,
  pick,
  pickBy,
  pipe,
  replace,
  some,
  split,
  trim,
  values,
} from 'lodash/fp';
import { useCallback } from 'react';

const parseTaxonomy = (filters: string) => pipe(trim, replace(/\s/g, ''), split(','))(filters);
const isFilterIsPartnerOnly = (facet: string, filterValue: any, partnerOnlyTaxonomies: any) =>
  pipe(
    pickBy((_: any, key: any) => includes(facet, key)),
    values,
    includes(filterValue.value),
  )(partnerOnlyTaxonomies);

const hasWildcard = (facetKey: string, partnerOnlyFilters: string[]) =>
  pipe(
    filter((filterItem: string) => filterItem.includes(facetKey)),
    some((filterItem: string) => filterItem.includes('/*')),
  )(partnerOnlyFilters);

export const usePartnerOnly = () => {
  const {
    taxonomy,
    config: { sso },
  } = usePageModels();

  const isPartnerOnlyFilter = useCallback(
    (facetName: string, filterOption: any) => {
      const partnerOnlyFilters = parseTaxonomy(sso?.ssoPartnerOnlyFilters || '');
      const facetKey = facetName?.replace('tax_', '')?.replace(/_/g, '-');

      if (hasWildcard(facetKey, partnerOnlyFilters)) return true;

      const partnerOnlyTaxonomies = pick(partnerOnlyFilters, taxonomy);
      return isFilterIsPartnerOnly(facetKey, filterOption, partnerOnlyTaxonomies);
    },
    [taxonomy, sso],
  );

  const facetHasPartnerOnlyFilters = useCallback(
    (facetName: string, facetOptionsValues: any[]) => {
      return some((item: string) => isPartnerOnlyFilter(facetName, item), facetOptionsValues);
    },
    [isPartnerOnlyFilter],
  );

  return { isPartnerOnlyFilter, facetHasPartnerOnlyFilters };
};
